import { Route } from "react-router";

import React from "react";
import { ProtectedRoute } from "./components";
import { AddCompany, SubsidiaryList } from "@/pages";
import {
  permissionsCompaniesReadonly,
  permissionsCompaniesFull,
} from "@/utils";
import { locationRoutes } from "./locationRoutes";

type argsType = {
  showLocations?: boolean;
  showAddLocation?: boolean;
  showEditLocation?: boolean;
  showDeleteLocation?: boolean;
  showAddCompany?: boolean;
  showEditCompany?: boolean;
};

export const companyRoutes = (
  parentPath: string,
  args: argsType = {},
): React.ReactElement[] => [
  <Route
    key="child-companies"
    path="child-companies"
    element={
      <ProtectedRoute
        element={
          (
            <SubsidiaryList
              parentPath={parentPath}
              showLocations={args?.showLocations}
              showAdd={args?.showAddCompany}
              showEdit={args?.showEditCompany}
            />
          ) as React.ReactElement<any>
        }
        codes={permissionsCompaniesReadonly}
      />
    }
  />,
  <Route
    key="add-child-company"
    path="child-companies/add"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,
  <Route
    key="edit-child-company"
    path="child-companies/edit/:id"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,
  <Route
    key="edit-child-company-alt"
    path="child-companies/:id/edit"
    element={
      <ProtectedRoute
        element={<AddCompany />}
        codes={permissionsCompaniesFull}
      />
    }
  />,
  <Route path="child-companies/:childCompanyId/locations">
    {locationRoutes(parentPath, args)}
  </Route>,
];
